<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="account_delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show>{{ $t('simple.delete_confirm') }}</b-alert>
                <b-alert variant="warning" show v-if="errorMsg">{{ errorMsg }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                 title: !user_permissions.includes('delete-accounts')? $t('permission.permission_denied', { permission: 'delete-accounts' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button  @click="account_remove" variant="primary" :class="!user_permissions.includes('delete-accounts') ? 'cursor-not-allowed' : ''"
                         :disabled="!user_permissions.includes('delete-accounts')">{{ $t('simple.delete') }}</b-button>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";
    export default {

        mounted: function () {
            console.log('Account Remove Modal mounted');
        },

        destroyed() {
            console.log('Account Remove Modal destroyed.');
        },

        data: function() {
             return  {
                accounts_api: '/api/v1/settings/accounts/',
                errorMsg: '',
             }
        },

        methods: {

            account_remove: async function(){

                // Loading start
                this.$wait.start('account_delete');
                this.errorMsg = '';

                // Delete account
                await axios.delete(this.accounts_api + this.id)
                .then((response) => {

                    // Show success
                    Vue.toasted.success(this.$t('simple.deleted_confirmed'));

                    // Loading stop
                    this.$wait.end('account_delete');

                    // Close modal and trigger list refresh
                    this.$close(true);
                })
                .catch((error) => {

                    // Loading stop
                    this.$wait.end('account_delete');

                    if (error.response && error.response.status === 422) {
                        this.errorMsg = error.response.data.errors?.account?.[0] ?? this.$t('simple.error_info');
                    } else if (error.response && error.response.status === 403) {
                        Vue.toasted.error(this.$t('permission.permission_denied', { permission: 'delete-accounts' }));
                        this.$close(false);
                    } else {
                        Vue.toasted.error(this.$t('simple.error_info'));
                        this.$close(false);
                    }
                });

            },
        },
      computed: {
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        })
      },
    }
</script>